<template>
  <!-- 首页 -->
  <div id="indexPage" class="pageContainer">
    <div class="test"></div>
    <!-- 大圆盘 -->
    <div class="btnChange">
      <div class="btnChange-child btn-fg" @click.stop="btnClick('fg')"></div>
      <div class="btnChange-child btn-ss" @click.stop="btnClick('ss')"></div>
      <div class="btnChange-child btn-zh" @click.stop="btnClick('zh')"></div>
    </div>
    <!-- 微信浏览器 -->
    <div v-if="isWX" class="loginChange1">
      <div
       class="loginChange-child1 btn-long1-wx"
       @click.stop="wxBrowerLogin">
        <van-image :src="wxImg"/>
      </div>

      <div
        class="loginChange-child1 btn-long1-userid"
        @click.stop="otherLoginWay">
        <van-image :src="accountImg"/>
      </div>
      
      <div class="callUsTelephone">服务热线：028-66612366</div>
    </div>
    <!-- 登录按钮 非微信 -->
    <div v-else-if="!userId && !isWX" class="loginChange">
      <!-- <div class="loginChange-child btn-you" @click="touristLogin"></div> -->
      <div
        class="loginChange-child btn-login"
       @click.stop="login">
        <van-image :src="loginImg"/>
      </div>

      <div
        class="loginChange-child btn-test"
       @click="applyLogin">
        <van-image :src="regImg"/>
      </div>

      <!-- <div class="loginChange-child btn-login" @click.stop="login"></div>
      <div class="loginChange-child btn-test" @click="applyLogin"></div> -->
      <div class="callUsTelephone">服务热线：028-66612366</div>
    </div>
    <!-- 进入界面 非微信 -->
    <div v-else-if="userId && !isWX" class="loginChange1">
      <div
        class="loginChange-child1 btn-login1"
        @click.stop="login">
        <van-image :src="enterImg"/>
      </div>
      <!-- <div class="loginChange-child1 btn-login1" @click.stop="login"></div> -->
      <div class="callUsTelephone">服务热线：028-66612366</div>
    </div>

    <audio id="bgMusic">
      <source src="../assets/indexAudio/btnChange.mp3" type="audio/mp3" />
    </audio>
    <audio id="loginMusic">
      <source src="../assets/indexAudio/btnLogin.mp3" type="audio/mp3" />
    </audio>
    <div class="ss"></div>
    <div class="zh"></div>
    <div class="fg"></div>
    <login ref="alertModel"></login>

    <van-overlay :show="showLoading" @click="showLoading = false">
      <div class="wrapper" @click.stop>
        <div class="loading">数据加载中。。</div>
        <!-- <van-loading type="spinner"></van-loading> -->
      </div>
    </van-overlay>

  </div>
</template>

<script>
import Login from "@/components/common/login";
import TripleDES from "@/utils/lib/crypto.js";
import { getUrlParam } from "@/utils/lib/searchtoobj.js";
import {
  getTempLogin,
  getTempLocation,
  GETANYTHING,
} from "@/utils/lib/tempLogin.js"; // 临时登录
// import { searchToObj } from "@/utils/lib/searchtoobj.js";
// 微信登录重定向到的URL
import { wxRedirectUrl, getWxConfigUrl } from "../../public/config.json";
import { wxConfig } from "@/utils/newLibs/getWxOptions.js";
import { getNoWxLocation } from "@/utils/newLibs/getNoWxLocation.js";
import { commonDialog, commonToast } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      loginNum: 0,
      applyLoginNum: 0,
      clickNum: 0,
      value: "fg",
      owx: "",
      showLoading: false,
      showApplyLogin: false,
      regMoblie: "", // 申请试用弹框 手机号码
      regCode: "", // 申请试用弹框 验证码
      errMsg: {
        mobilePhone: "", // 手机号码
        code: "", // 验证码
      },
      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      btntxt: "发送验证码",
      disabled: false, // 禁用发送验证码按钮
      time: 0, // 倒计时
      showLoginForm: false, // 展示登录信息表格
      wxImg: require("../assets/indexImg/wxlogin1.png"),
      accountImg:require("../assets/indexImg/useridlogin1.png"),
      loginImg:require("../assets/indexImg/login.png"),
      regImg: require("../assets/indexImg/reg.png"),
      enterImg: require("../assets/indexImg/dl2.png"),
      touristImg: require("../assets/indexImg/you.png")
    };
  },
  components: {
    Login
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    userguid() {
      return this.$store.state.user.userGuid;
    },
    isWX: {
      get() {
        return Number(localStorage.getItem("WX_VERSION"));
      },
      set() {},
    },
  },
  created() {

    if(this.$route.query.shareUserGuid) {
      localStorage.setItem("shareUserguid", this.$route.query.shareUserGuid)
      this.WXLogIn()
    }
    console.log("cookie取值", this.$cookie.get("cookieObj"));
    console.log("sessionStorage取空值",sessionStorage.getItem("userId"));
    //没有登录过
    if (
      this.userId == "" &&
     sessionStorage.getItem("userId") === null &&
      this.$cookie.get("cookieObj") === null
    ) {
      this.templogin();
    }

    // 微信环境下退出之后重新登录 还有cookie
    if (
      this.isWX === 1 &&
      this.userId !== "" &&
     sessionStorage.getItem("userId") === null &&
      this.$cookie.get("cookieObj") !== null
    ) {
      //-91回首页，不走此流程
      this.$cookie.delete("cookieObj");
      this.templogin();
    }

    // 非微信退出登录
    if (
      this.isWX === 0 &&
      this.userId !== "" &&
     sessionStorage.getItem("userId") === null &&
      this.$cookie.get("cookieObj") !== null
    ) {
      console.log(4);
      console.log("非微信退出token", this.$store.state.user.token);
      this.refreshToken();
    }

    if (this.$route.query.o) {
      console.log(5);
      this.owx = this.$route.query.o;
      this.$store.commit("user/setOwx", this.owx);
    }
  },
  methods: {
    author2(){
    if(this.$route.query.reg) {
      sessionStorage.setItem("linkReg", this.$route.query.reg);
      console.log(this.$store.state.user.userGuid)
      this.WXLogIn()
    }
    // 扫码推广码
    if(getUrlParam(location.search, 'scan')) {
        sessionStorage.setItem("spreadCode", getUrlParam(location.search,'code'))
        this.WXLogIn()
      }
    },
    // 临时登录
    templogin() {
      new Promise((ok, err) => {
        getTempLogin(ok);
      }).then(() => {
        return new Promise((ok, err) => {
          GETANYTHING();
          this.author2()
        });
       //this.WXLogIn();
      });
    },
    // 刷新token
    refreshToken(loginWay) {
      this.$http.refreshToken().then((resp) => {
        console.log("resp888", resp);
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.bus.$emit("saveTokenHandle", resp, loginWay);

            if (resp.accountstatus == 100) {
              // 试用期
              console.log("当前用户状态:试用期");
              this.$router.push("/newFiles");
            } else if (resp.accountstatus == 107) {
              // 试用期到期7天内
              this.showMsgDialog(resp.showmsg);
            } else if (resp.accountstatus == 207) {
              // 正常使用到期7天内
              this.showMsgDialog(resp.showmsg);
            } else if (resp.accountstatus == 300) {
              // 试用期满进入冻结期
              this.onlygoMall(resp.showmsg);
            } else if (resp.accountstatus == 400) {
              // 正常使用到期进入冻结期 只能浏览商城
              this.onlygoMall(resp.showmsg);
            } else if (resp.accountstatus == 200) {
              // 正常使用
              console.log("当前用户状态:正常使用");
              if (this.isWX == 1) {
                this.$router.push("/newFiles");
              }
            } else if (resp.showmallbutton) {
              this.onlygoMall(resp.showmsg);
            } else if (resp.showmsg) {
              this.showMsgDialog(resp.showmsg);
            } else {
              if(loginWay == 0) {
                if(this.$cookie.get('cookieObjByUserid')) {
                  this.$router.push("/newFiles")
                } else {
                   // 账号登录
                  this.$refs.alertModel.changeShowLogin(true);
                }
              } else {
                if(this.$cookie.get('cookieObjByWx')) {
                  this.$router.push("/newFiles");
                } else {
                  new Promise((ok, err) => {
                    getTempLogin(ok);
                  }).then(() => {
                    this.WXLogIn();
                  });
                }
              }
            }
          } else {
            commonDialog(resp.rltdesc, this, "关闭", () => {
              this.$cookie.delete("cookieObjByUserid");
              this.$cookie.delete("cookieObjByWx");
            });
          }
        } 
      });
    },
  clearData() {
      store.commit("user/setUserId", "");
      store.commit("user/setUserGuid", "");
      store.commit("user/setWxOpenId", "");
      store.commit("user/setWxUnionId", "");
      store.commit("user/setAgentCode", "");
      store.commit("user/setWxgenerateId", "");
      store.commit("user/setRealName", "");
      store.commit("user/setToken", "");
      store.commit("user/setMobileNum", "");
      store.commit("user/setAccountType", 0);
      store.commit("user/setPermission", []);
      store.commit("user/setAccountStatus", 0);
      store.commit("user/setShowMsg", "");
      store.commit("user/setPermissionArray", []);

      sessionStorage.clear();
      VueCookie.delete("cookieObj");
      VueCookie.delete("cookieObjByUserid");
      VueCookie.delete("cookieObjByWx");
    },
    btnClick(value) {
      if (!this.userId) {
        if (value === "fg") {
          document.querySelector("#indexPage").className = "pageContainer fg";
          if (this.userId === "" && this.isWX) {
            return;
          }
          this.$router.replace("main");
        }
        if (value === "ss") {
          document.querySelector("#indexPage").className = "pageContainer ss";
          if (this.userId === "" && this.isWX) {
            return;
          }
          this.$router.replace("searchEngine");
        }
        if (value === "zh") {
          document.querySelector("#indexPage").className = "pageContainer zh";
          if (this.userId === "" && this.isWX) {
            return;
          }
          commonToast("请先登录后再试用智慧云端", this);
        }
      } else {
        if (this.value !== value) {
          document.querySelector("#bgMusic").currentTime = 0;
          document.querySelector("#bgMusic").play();
        }
        if (value === "fg") {
          this.goToHomePage(0);
          document.querySelector("#indexPage").className = "pageContainer fg";
        }
        if (value === "ss") {
          this.goToHomePage(1);
          document.querySelector("#indexPage").className = "pageContainer ss";
        }
        if (value === "zh") {
          this.goToHomePage(2);
          document.querySelector("#indexPage").className = "pageContainer zh";
        }
        this.value = value;
      }
    },
    goToHomePage(item) {
      this.clickNum = item;
      this.$store.state.changeVersion.jumpPage = item;
      if (item === 0) {
        this.$store.commit("commonSearchData/changeActiveName", "a");
        localStorage.setItem("selectedId", "a");
        setTimeout(() => {
          this.$router.replace("main");
        }, 1000);
      } else if (item === 1) {
        this.$store.commit("commonSearchData/changeActiveName", "b");
        localStorage.setItem("selectedId", "b");
        setTimeout(() => {
          this.$router.replace("searchEngine");
        }, 1000);
      } else if (item === 2) {
        this.$store.commit("commonSearchData/changeActiveName", "c");
        localStorage.setItem("selectedId", "c");

        localStorage.setItem("changeFlag", true);
        localStorage.setItem("changeFlagWord", "全国版");
        this.$store.commit("changeVersion/setChangeFlag", true);
        this.$store.commit("changeVersion/setChangeFlagWord", "全国版");
        setTimeout(() => {
          this.$router.replace("smartcloud");
        }, 1000);
      }
    },
    // 登录按钮
    login() {
      new Promise((resolve, reject) => {
        this.getLocation(resolve);
      }).then(() => {
        console.log("点击了登录按钮", this.clickNum);
        if (this.clickNum === 0) {
          this.$store.commit("commonSearchData/changeActiveName", "a");
          localStorage.setItem("selectedId", "a");
        } else if (this.clickNum === 1) {
          this.$store.commit("commonSearchData/changeActiveName", "b");
          localStorage.setItem("selectedId", "b");
        } else if (this.clickNum === 2) {
          this.$store.commit("commonSearchData/changeActiveName", "c");
          localStorage.setItem("selectedId", "c");
        }
        document.querySelector("#loginMusic").currentTime = 0;
        document.querySelector("#loginMusic").play();
        if (!this.userId) {
          this.$refs.alertModel.changeShowLogin(true); // 弹出登录框
        } else if (
          this.userId &&
          (this.$store.state.user.accountstatus == 400 ||
            this.$store.state.user.accountstatus == 300) &&
          this.$store.state.user.permissionArray.includes("900001")
        ) {
          this.$router.replace("onlineMall");
        } else if (this.userId && this.$store.state.user.accountstatus != 400) {
          this.$router.replace("newFiles");
        }
      });
    },
    // 申请试用按钮
    applyLogin() {
      new Promise((resolve, reject) => {
        this.getLocation(resolve);
      }).then(() => {
        document.querySelector("#loginMusic").currentTime = 0;
        document.querySelector("#loginMusic").play();
        this.$refs.alertModel.changeShowApplyLogin(true); // 弹出申请试用框
      });
    },
    // 游客登录按钮
    touristLogin() {
      new Promise((resolve, reject) => {
        this.getLocation(resolve);
      }).then(() => {
        console.log("this.$store.state.user", this.$store.state.user);
        console.log("点击了游客登录按钮");
        this.$router.push("/newFiles");
      });
    },
    // 提示弹框
    showMsgDialog(showmsg) {
      this.$dialog
        .confirm({
          title: "提示",
          message: showmsg,
          confirmButtonText: "在线商城",
          cancelButtonText: "关闭",
        })
        .then(() => {
          if (this.$store.state.user.permissionArray.includes("900001")) {
            this.$router.push("onlineMall");
          }
        })
        .catch((err) => {
          // 取消
          this.$router.push("newFiles");
        });
    },
    // 300 400提示弹框
    onlygoMall(showmsg) {
      this.$dialog
        .confirm({
          title: "提示",
          message: showmsg,
          confirmButtonText: "在线商城",
          cancelButtonText: "退出登录",
        })
        .then(() => {
          if (this.$store.state.user.permissionArray.includes("900001")) {
            this.$router.push("onlineMall");
          }
        })
        .catch(() => {
          sessionStorage.clear();
          localStorage.removeItem('accoutName')
          localStorage.removeItem('accoutPwd')
          
          this.$cookie.delete("cookieObj");
          console.log(this.$store.state.changeSomeThing.loginWay);
          this.$store.commit("user/setUserId", "");

          if (this.$store.state.changeSomeThing.loginWay == 0) {
            this.$cookie.delete("cookieObjByUserid");
          } else if (this.$store.state.changeSomeThing.loginWay == 1) {
            this.$cookie.delete("cookieObjByWx");
          }
          location.reload();
        });
    },
    // 微信内点击账号登录方式
    otherLoginWay() {
      console.log("账号登录开始");
      this.$store.commit("changeSomeThing/setLoginWay", 0);

      if (this.$cookie.get("cookieObjByUserid") !== null) {
        // 登录过，直接刷新token就好
        this.showLoading = true;
        let cookieData = TripleDES.decode(
          "token",
          JSON.parse(this.$cookie.get("cookieObjByUserid"))
        );
        console.log("执行前的更新token0", this.$store.state.user.token);
        console.log(cookieData);
        this.$store.commit("user/setToken", cookieData.token);
        this.$store.commit("user/setUserGuid", cookieData.userguid);

        this.refreshToken(0)
      } else {
        this.$refs.alertModel.changeShowLogin(true);
        this.getLocation(() => {});
      }
    },
    // 微信内点击微信登录
    wxBrowerLogin() {
      this.showLoading = true;
      this.$store.commit("changeSomeThing/setLoginWay", 1);
      if (this.$cookie.get("cookieObjByWx") !== null) {
        // 登录过，直接刷新token就好
        let cookieData = TripleDES.decode(
          "token",
          JSON.parse(this.$cookie.get("cookieObjByWx"))
        );
        console.log("执行前的更新token%", this.$store.state.user.token);
        console.log(cookieData);

        this.$store.commit("user/setToken", cookieData.token);
        this.$store.commit("user/setUserGuid", cookieData.userguid);
        this.refreshToken(1)
      } else {
        document.querySelector("#loginMusic").currentTime = 0;
        document.querySelector("#loginMusic").play();
        new Promise((resolve, reject) => {
          this.getLocation(resolve);
        }).then(() => {
          setTimeout(() => {
            this.WXLogIn();
          }, 2000)
        })
      }
    },
    //微信内点击微信登录1
    // 微信登录
    WXLogIn() {
      let req = {
        http_redirct: wxRedirectUrl,
      };
      this.$http
        .reqPostGetWeixinPromise(req)
        .then((res) => {
          console.log("res123123", res); // 返回的
          location.href = res.item.url;
        })
    },
    // 调用微信的SDK
    getLocation(resolve) {
      if (this.isWX == 1) {
        // 微信浏览器
        let reqBody = {
          url: getWxConfigUrl,
        };
        // return;
        this.$http
          .reqGetWxConfig(reqBody)
          .then((res) => {
            console.log("reqGetWxConfig=====>")
            console.log(JSON.stringify(res))
            new Promise((ok, err) => {
              wxConfig(res, ok, err);
            })
              .catch((err) => console.log(err))
              .finally(() => {
                let x = localStorage.getItem("latitude")
                    ? localStorage.getItem("latitude")
                    : 0,
                  y = localStorage.getItem("longitude")
                    ? localStorage.getItem("longitude")
                    : 0;
                getTempLocation(resolve, x, y);
                this.showLoading = false;
              });
          })
          .catch((err) => {
            this.showLoading = false;
          })
          .finally(() => {
            resolve();
          });
      } else {
        // 非微信浏览器
        if ("geolocation" in navigator) {
          // 可以使用定位
          new Promise((ok, err) => {
            getNoWxLocation(ok, err);
          })
            .catch((err) => console.log(err))
            .finally(() => {
              let x = localStorage.getItem("latitude")
                  ? localStorage.getItem("latitude")
                  : 0,
                y = localStorage.getItem("longitude")
                  ? localStorage.getItem("longitude")
                  : 0;
              getTempLocation(resolve, x, y);
            });
        } else {
          // 不可以使用定位
          getTempLocation(resolve);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
#indexPage {
  background:
    url(../assets/indexImg/fgbg.png),
    url(../assets/indexImg/csbg.jpg);
  background-repeat: no-repeat, no-repeat;
  background-size: 100% auto, 100% auto;
  background-position: 0 20px, 0 0;
  // .test {
  //   width: 100%;
  //   height: 180px;
  //   background:
  //   url(../assets/indexImg/title.png);
  //   background-repeat: no-repeat;
  //   background-size: 100% auto;
  //   margin: 20px 0 20px 0;
  // }
  .nav-box {
    background: #ea4f4f;
    color: white;
    width: 60%;
  }
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & > div {
      margin-top: 20px;
    }
  }
  .van-image--round {
    border-radius: 0%;
  }
}
#indexPage:before {
  content: "";
  display: table;
}
.btnChange {
  height: 5.3rem;
  width: 5.3rem;
  border-radius: 50%;
  margin: auto;
  left: 0;
  right: 0;
  top: 5.6rem;
  position: absolute;
  overflow: hidden;
  z-index: 10;
}
.btnChange-child {
  z-index: 1;
  position: absolute;
  width: 58%;
  height: 58%;
  left: 50%;
  top: 50%;
  transform-origin: 0% 0%;
}
.ss {
  background-image: url(../assets/indexImg/ssbg.png),
    url(../assets/indexImg/csbg.jpg) !important;
}
.fg {
  background-image: url(../assets/indexImg/fgbg.png),
    url(../assets/indexImg/csbg.jpg) !important;
}
.zh {
  background-image: url(../assets/indexImg/zhbg.png),
    url(../assets/indexImg/csbg.jpg) !important;
}
.btn-fg {
  transform: rotate(30deg) skewX(-30deg);
}
.btn-ss {
  transform: rotate(150deg) skewX(-30deg);
}
.btn-zh {
  transform: rotate(270deg) skewX(-30deg);
}
.loginChange {
  height: 1rem;
  width: 100%;
  position: absolute;
  top: 13.7rem;
  left: 0;
  display: flex;
  justify-content: space-between;
  &:before,
  &:after {
    content: "";
    display: block;
  }
  .callUsTelephone {
    position: absolute;
    top: 54px;
    left: 50%;
    transform: translateX(-50%);
    color: #FFFFFF;
  }
}
.loginChange1 {
  height: 45pt;
  width: 100%;
  position: absolute;
  top: 13rem;
  left: 0;
  display: flex;
  justify-content: space-between;
  &:before,
  &:after {
    content: "";
    display: block;
  }
  .changeLoginWay {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    color: #cf9462;
  }
  .callUsTelephone {
    position: absolute;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);
    color: #FFFFFF;
  }
}
.loginChange-child {
  width: 2.7rem;
  height: 100%;
}
.loginChange-child1 {
  width: 3.7rem;
  height: 100%;
}
// .btn-login {
//   background-image: url(../assets/indexImg/login.png);
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   -webkit-background-size: 100% 100%;
// }
// .btn-test {
//   background-image: url(../assets/indexImg/reg.png);
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   -webkit-background-size: 100% 100%;
// }
// .btn-login1 {
//   background-image: url(../assets/indexImg/dl2.png);
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   -webkit-background-size: 100% 100%;
// }
// .btn-long1-wx {
//   background-image: url(../assets/indexImg/wxlogin1.png);
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   -webkit-background-size: 100% 100%;
// }
// .btn-long1-userid {
//   background-image: url(../assets/indexImg/useridlogin1.png);
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   -webkit-background-size: 100% 100%;
// }
.btn-test1 {
  background-image: url(../assets/indexImg/reg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}
.btn-you {
  background-image: url(../assets/indexImg/you.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .loading {
    width: 100px;
    height: 100px;
    color: #fff;
  }
}
</style>
